import { isNumber } from 'lodash';

export const calculate_cz_price = (data: any, cz_rate: any) => {
  if (isNumber(data['price'])) {
    return ((data['price'] - data['zjfl'] - data['zjje']) * cz_rate).toFixed(0);
  }
  return 0;
};

export const calculate_fl_price = (data: any) => {
  if (isNumber(data['price'])) {
    return (data['price'] - data['zjfl'] - data['zjje'] - data['czje']).toFixed(0);
  }
  return 0;
};
